export default {
    columns: {
        title: 'Title',
        identifiedAt: 'Created at',
        author: 'Author',
        image: 'Image',
        country: 'Country',
        initiator: 'Initiator',
        megatrends: 'Mega-trends',
        macrotrends: 'Macro-trends',
        industry: 'Industry',
        innovationType: 'Innovation type'
    }
}
